import { z } from "zod";
import { WALLET_TRANSACTION_TYPES } from "../constants/wallet";
import { levelProgressSchema, streakSummarySchema } from "./progression";

export const walletTransactionTypeSchema = z.enum(WALLET_TRANSACTION_TYPES);

export const walletSummarySchema = z.object({
  balance: z.number().int(),
  updatedAt: z.string(),
});

export type WalletSummary = z.infer<typeof walletSummarySchema>;

export const walletTransactionSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: walletTransactionTypeSchema,
  amount: z.number().int(),
  balanceBefore: z.number().int(),
  balanceAfter: z.number().int(),
  referenceId: z.string().nullable(),
  metadata: z.record(z.unknown()).nullable(),
  createdAt: z.string(),
});

export type WalletTransactionDTO = z.infer<typeof walletTransactionSchema>;

/**
 * POST /api/v1/wallet/daily-reward — no body; idempotency is server-enforced
 * by JAIHO game day. Carries enough of the post-claim state (balance, XP,
 * level, streak) for the frontend to update immediately without a reload.
 */
export const claimDailyRewardResponseSchema = z.object({
  claimed: z.boolean(),
  amount: z.number().int(),
  xpAmount: z.number().int(),
  balance: z.number().int(),
  alreadyClaimedToday: z.boolean(),
  progression: levelProgressSchema,
  streak: streakSummarySchema,
});

export type ClaimDailyRewardResponse = z.infer<typeof claimDailyRewardResponseSchema>;
